import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { Navigation, Pagination } from 'swiper/modules';
import './slider.scss'; // Default slider styles. Override these per component basis.

/**
 * Generic slider class
 *
 * Assumes following structure, where ELEMENT is the element to be passed to constructor
 *
   <ELEMENT>
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="" alt="">
        </div>
        <div class="swiper-slide">
          <img src="" alt="">
        </div>
      </div>
    </div>
   </ELEMENT>
 */

type SliderOptions = {
  /** Use Swiper navigation module */
  navigation?: boolean;
  /** Use Swiper pagination module */
  pagination?: boolean;
  /** Use custom controls: add them to markup yourself */
  customControls?: boolean;
  /** Swiper options. See Swiper documentation for these */
  swiperOptions?: SwiperOptions;
};

export default class Slider {
  #instance;

  constructor(element: HTMLElement, options: SliderOptions) {
    const swiperElement = element.getElementsByClassName('swiper')[0];

    const defaultSettings = {
      navigation: true,
      pagination: true,
      customControls: false,
    };

    const settings = Object.assign({}, defaultSettings, options);

    if(!settings.customControls) {
      if(settings.pagination) {
        swiperElement.appendChild(document.createElement('div')).classList.add('swiper-pagination');
      }

      if(settings.navigation) {
        swiperElement.appendChild(document.createElement('div')).classList.add('swiper-button-prev');
        swiperElement.appendChild(document.createElement('div')).classList.add('swiper-button-next');
      }
    }

    const swiperSettings = {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      ...settings.swiperOptions,
      modules: [
        settings.navigation ? Navigation : null,
        settings.pagination ? Pagination : null,
      ].filter(module => module !== null),
    };

    this.#instance = new Swiper(element.getElementsByClassName('swiper')[0] as HTMLElement, swiperSettings);

    console.log('Slider.init()');
  }
}

/**
 * Use data attributes for configuration.
 * If using custom controls, add them to markup yourself using the classes "swiper-pagination", "swiper-button-prev" and "swiper-button-next"
 * @example

<div class="js-slider" data-navigation="true" data-pagination="true">
 */
export function init(elements: NodeListOf<HTMLElement>) {
  Array.from(elements).forEach(element => {

    new Slider(element, {
      navigation: element.getAttribute('data-navigation') === 'true',
      pagination: element.getAttribute('data-pagination') === 'true',
      customControls: element.getAttribute('data-custom-controls') === 'true',
    });
  });
}
